export default __webpack_public_path__ + "static/joko-app-screenshot-home-3-fr@2x-64b468b9f1011a946f268292decf7659.png";